// extracted by mini-css-extract-plugin
module.exports = {"vesting":"Vesting_vesting__1DOry"};